import { UserApi } from "../../../../api";
import { throwErrorToastrAsync } from "../../../../utils";
import { setLoading, userSignupTypesReceived } from "../../../reducers/user/signup/types";
import { AppThunk } from "../../../store";

const userSignupApi = new UserApi();

export const fetchUserSignupTypesAction = (): AppThunk => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await userSignupApi.getUserSignupTypesAsync();
        dispatch(userSignupTypesReceived(response));
    } catch (error) {
        throwErrorToastrAsync(error);
    } finally {
        dispatch(setLoading(false));
    }
};
